import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconChevronDoubleRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 12,
	viewBox: "0 0 15 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7 10.59L11.58 6L7 1.41L8.41 0L14.41 6L8.41 12L7 10.59Z",
		fill: "black",
		fillOpacity: .87
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0 10.59L4.58 6L0 1.41L1.41 0L7.41 6L1.41 12L0 10.59Z",
		fill: "black",
		fillOpacity: .87
	})]
});
export default SvgIconChevronDoubleRight;
